import { Sentry, generateRandomId } from '@guuru/sentry-web';

const sessionId = generateRandomId();

const tracingHeaders = (operationName?: string) => {
  const requestId = generateRandomId();

  Sentry.addBreadcrumb({
    category: 'graphql.request',
    data: {
      operation_name: operationName,
      request_id: requestId,
      session_id: sessionId,
    },
    level: 'info',
  });

  return {
    'X-Request-ID': requestId,
    'X-Session-ID': sessionId,
  };
};

export default tracingHeaders;
